// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__IlXj0","form":"styles_form__2mfFX"};